module.exports = "/static/img/texture-fg.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen3/water/img/texture-fg.png
// module id = 466
// module chunks = 0